import { Button as MuiButton, Popover as MuiPopover } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Button = styled(MuiButton, {
  shouldForwardProp: (prop) => prop !== "isIcon",
})<{ isIcon: boolean }>({}, ({ isIcon, theme }) => ({
  ...(isIcon && {
    minWidth: 30,
    fontSize: "1em",
    color: theme.palette.text.primary,
  }),
}));

export const Popover = styled(MuiPopover, {
  shouldForwardProp: (prop) => prop !== "flow",
})<{ flow?: "row" | "column" }>(({ flow }) => ({
  "& > .MuiPaper-root": {
    display: "flex",
    flexFlow: flow ?? "column",
    overflow: "visible",

    "& > .MuiButton-root, & > .MuiGrid-root .MuiButton-root": {
      width: "100%",
      fontSize: ".9em",
      textTransform: "uppercase",
      textAlign: "center",
      padding: "5px",
    },
  },
}));
